<script>

    import { _ } from 'svelte-i18n';
    import { goto } from '../helpers/navigation.svelte.js';

    import Icon from './Icon.svelte';
    import aiIcon from '../assets/icons/ai.svg?raw';

    function open() {
        goto('chat', 'right');
    }

</script>

<button class="launcher" onclick={open} aria-label={$_('chatbot_open')}>
    <Icon data={aiIcon} size="28px" />
    <span class="tooltip" aria-hidden="true">{$_('chatbot_button')}</span>
</button>

<style>

    /* Bottom-right of the widget card on desktop; bottom-right of the screen on
       mobile (where the widget fills the viewport). */
    .launcher {
        position: absolute;
        bottom: 20px;
        right: -28px;
        width: 56px;
        height: 56px;
        border-radius: 50%;
        border: none;
        background: var(--accent-background);
        color: var(--accent-color);
        cursor: pointer;
        box-shadow: 0 4px 16px rgba(0, 0, 0, 0.25);
        z-index: 10;
        display: flex;
        align-items: center;
        justify-content: center;
    }

    @media (max-width: 600px) {
        .launcher {
            position: fixed;
            right: 20px; /* keep the small-viewport position; only desktop overhangs */
        }
    }

    /* Hover/focus tooltip, sitting to the LEFT of the round button with a triangle
       pointing right towards it. Uses the theme's text/background pair so it stays a
       contrasting bubble in any theme. */
    .tooltip {
        position: absolute;
        right: calc(100% + 16px); /* left of the button; 10px leaves room for the triangle */
        top: 50%;
        transform: translateY(-50%) translateX(6px);

        background: var(--text-color);
        color: var(--background-color);
        padding: 1em 1.2em;
        border-radius: 8px;
        font-size: 0.9rem;
        line-height: 1;
        white-space: nowrap;
        box-shadow: 0 4px 16px rgba(0, 0, 0, 0.25);

        opacity: 0;
        pointer-events: none;
        transition: opacity 0.15s ease, transform 0.15s ease;
    }

    /* Triangle on the tooltip's right edge, pointing at the button. */
    .tooltip::after {
        content: '';
        position: absolute;
        left: 100%;
        top: 50%;
        transform: translateY(-50%);
        border: 6px solid transparent;
        border-left-color: var(--text-color);
    }

    .launcher:hover .tooltip,
    .launcher:focus-visible .tooltip {
        opacity: 1;
        transform: translateY(-50%) translateX(0);
    }

</style>
